
export default function ValueProposition() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Save 95% of Your Time',
      description: 'Eliminate hours of manual data entry. Process invoices in seconds, not hours.',
      stat: '95% Time Saved'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cut Costs by 80%',
      description: 'No more hiring clerks or expensive outsourcing. One simple monthly fee.',
      stat: '80% Cost Reduction'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Improve Accuracy to 99.9%',
      description: 'Advanced AI eliminates human errors and ensures perfect data extraction.',
      stat: '99.9% Accuracy'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Smart Way to Handle Invoices
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your accounting workflow with intelligent automation that pays for itself in the first month.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
              </div>
              <div className="text-3xl font-bold text-blue-600 mb-2">{benefit.stat}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
